'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$GroupingId$() {
  this.c8d = null;
  this.c8e = false;
  this.c8b = null;
  this.c8c = false;
}
export { $c_Lpresto_types$GroupingId$ as $c_Lpresto_types$GroupingId$ };
$p = $c_Lpresto_types$GroupingId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$GroupingId$;
/** @constructor */
function $h_Lpresto_types$GroupingId$() {
}
export { $h_Lpresto_types$GroupingId$ as $h_Lpresto_types$GroupingId$ };
$h_Lpresto_types$GroupingId$.prototype = $p;
$p.Tm = (function() {
  if ((!this.c8e)) {
    this.c8d = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j9;
    this.c8e = true;
  }
  return this.c8d;
});
$p.nN = (function() {
  if ((!this.c8c)) {
    this.c8b = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().e1;
    this.c8c = true;
  }
  return this.c8b;
});
var $d_Lpresto_types$GroupingId$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$GroupingId$, "presto.types$GroupingId$", ({
  a0r: 1,
  D: 1
}));
export { $d_Lpresto_types$GroupingId$ as $d_Lpresto_types$GroupingId$ };
var $n_Lpresto_types$GroupingId$;
function $m_Lpresto_types$GroupingId$() {
  if ((!$n_Lpresto_types$GroupingId$)) {
    $n_Lpresto_types$GroupingId$ = new $c_Lpresto_types$GroupingId$();
  }
  return $n_Lpresto_types$GroupingId$;
}
export { $m_Lpresto_types$GroupingId$ as $m_Lpresto_types$GroupingId$ };
//# sourceMappingURL=presto.types$-Grouping-Id$.js.map
